import { useMetadata } from '@/hooks/useMetadata';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { FC, useId } from 'react';

type DataTypeSelectProps = {
  value: string;
  typelist: string;
  onChange: (type: string) => void;
  disabled?: boolean;
};

const DataTypeSelect: FC<DataTypeSelectProps> = (props) => {
  const { metadata } = useMetadata();
  // One of these renders per argument and per return type, so the label can only find its select by a unique id.
  const selectId = useId();

  return (
    <>
      <InputLabel id={`${selectId}-label`}>Type</InputLabel>
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        value={props.value}
        label='Type'
        disabled={props.disabled}
        onChange={(e) => props.onChange(e.target.value)}
        sx={{ minWidth: 100 }}
      >
        {metadata.typelists
          ?.find((typelist) => typelist.name === props.typelist)
          ?.types?.map((valType, index) => (
            <MenuItem key={`type.select.${valType}.${index}`} value={valType}>
              {metadata.datatypes?.find((datatype) => datatype.type === valType)?.label || valType}
            </MenuItem>
          ))}
      </Select>
    </>
  );
};

export default DataTypeSelect;
